// extracted by mini-css-extract-plugin
export var icon = "_58-1";
export var subtext = "_58-0";